<template>
  <div class="choose-med-type">
    <div v-if="initialized" class="med-container" id="choose-med-type-container">
      <div class="text-center">
        <img src="~@/assets/logo.svg" class="logo" />
        <div class="title">{{ $t("med-type.title") }}</div>
        <div class="description">
          {{ $t("med-type.description") }}
        </div>
      </div>

      <div class="mb-40" id="select-med-key-type-section">
        <label class="label">Med-Key-Type</label>
        <v-select
          v-model="medKeyType"
          :options="availableMedKeyTypes"
          title-property="name"
          value-property="key"
          :placeholder="$t('common.choose')"
          :disabled="!availableMedKeyTypes"
        />
      </div>

      <div class="text-right">
        <v-button
          id="med-key-type-choice-confirmation-button"
          primary
          :disabled="!medKeyType"
          @click="
            $router.push({
              name: 'myPills',
              params: {
                location: location,
                medKeyType: medKeyType
              }
            })
          "
        >
          {{ $t("common.continue") }}
          <img v-if="medKeyType" src="~@/assets/icons/arrow-white.svg" />
          <img v-else src="~@/assets/icons/arrow-grey.svg" />
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VButton, VSelect } from "shared";
import * as MedKeyTypesDAO from "../dao/med-key-types-dao";

export default {
  name: "PChooseMedType",
  components: {
    VButton,
    VSelect
  },
  data() {
    return {
      location: null,
      medKeyType: null,
      availableMedKeyTypes: null,
      initialized: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/userDetails"
    })
  },
  methods: {
    async fetchMedKeyTypes(location) {
      this.availableMedKeyTypes = await MedKeyTypesDAO.getMedKeyTypes(location);
      if (this.availableMedKeyTypes.length === 1) {
        this.medKeyType = this.availableMedKeyTypes[0].key;
      } else {
        this.medKeyType = null;
      }
    }
  },
  async created() {
    this.location = this.user.locationId;
    await this.fetchMedKeyTypes(this.location);
    this.initialized = true;
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.choose-med-type {
  min-height: 100vh;
  position: relative;
}

.med-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 226px;
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translate(-50%, 0);
}

.logo {
  margin-bottom: 17px;
}

.title {
  font-size: 24px;
  margin-bottom: 14px;
  letter-spacing: 0.8px;
  color: #333333;
}

.description {
  font-size: 13px;
  line-height: 14px;
  margin-bottom: 27px;
}

.label {
  font-size: 13px;
  color: $color-medium-grey;
  margin-bottom: 8px;
  display: inline-block;
  font-weight: bold;
  letter-spacing: 0.4px;
}
::v-deep .options {
  width: 100%;
}
</style>
